import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-logout",
  "use": "icon-logout-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-logout\"><path d=\"M575.8 144.7v64.9c140.2 29.6 245.7 154.1 245.7 303 0 170.8-138.9 309.7-309.7 309.7C341 822.2 202 683.3 202 512.5c0-148.8 105.6-273.4 245.7-303v-64.9C271.9 175.1 138 328 138 512.5c0 206.4 167.3 373.7 373.7 373.7s373.7-167.3 373.7-373.7c0.1-184.5-133.8-337.4-309.6-367.8z\" /><path d=\"M479.7 101.3h64v358.3h-64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol